export enum PbhRequestedInfoType {
  None = 0,
  OffCorePnSn = 1,
  CodingSheet = 2,
  IPC = 3,
  CMM = 4,
  EndUserForm = 5,
  Other = 6,
  RemovalDefectDetails = 7,
  MpdDetails = 8
}

export const PbhRequestedInfoTypeSelectionChoices = [
  { key: PbhRequestedInfoType.OffCorePnSn, value: "Off-core PN/SN" },
  { key: PbhRequestedInfoType.CodingSheet, value: "Coding Sheet" },
  { key: PbhRequestedInfoType.IPC, value: "IPC" },
  { key: PbhRequestedInfoType.CMM, value: "CMM" },
  { key: PbhRequestedInfoType.EndUserForm, value: "End User Form" },
  { key: PbhRequestedInfoType.Other, value: "Other" },
  { key: PbhRequestedInfoType.RemovalDefectDetails, value: "Removal/Defect Details" },
  { key: PbhRequestedInfoType.MpdDetails, value: "MPD Task Details" }
];
